import { render, staticRenderFns } from "./purchaseOrderContainerPurchaseList.vue?vue&type=template&id=2cd064c8&scoped=true&"
import script from "./purchaseOrderContainerPurchaseList.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderContainerPurchaseList.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrderContainerPurchaseList.vue?vue&type=style&index=0&id=2cd064c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd064c8",
  null
  
)

export default component.exports